import { CheckCircle2, XCircle, Clock } from "lucide-react";
import { formatDisplayValue } from "../lib/display";
import { cn } from "../lib/utils";

const statusConfig = {
  faturado: {
    className: "bg-green-100 text-green-700",
    icon: CheckCircle2,
  },
  cancelado: {
    className: "bg-red-100 text-red-700",
    icon: XCircle,
  },
  devolvida: {
    className: "bg-amber-100 text-amber-800",
    icon: XCircle,
  },
  "parcialmente devolvida": {
    className: "bg-amber-100 text-amber-800",
    icon: Clock,
  },
  pendente: {
    className: "bg-yellow-100 text-yellow-700",
    icon: Clock,
  },
};

const normalizeSaleStatus = (status) => {
  const normalized = String(status || "Faturado").trim().toLowerCase();
  if (normalized.includes("cancel")) return "cancelado";
  if (normalized.includes("parcial") && normalized.includes("devol")) return "parcialmente devolvida";
  if (normalized.includes("devol")) return "devolvida";
  if (normalized.includes("pend")) return "pendente";
  if (normalized.includes("fat")) return "faturado";
  return normalized || "faturado";
};

const SaleStatusBadge = ({ status, className }) => {
  const normalizedStatus = normalizeSaleStatus(status);
  const config = statusConfig[normalizedStatus] || {
    className: "bg-slate-100 text-slate-700",
    icon: Clock,
  };
  const Icon = config.icon;

  return (
    <span
      className={cn(
        "inline-flex w-fit shrink-0 items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium",
        config.className,
        className
      )}
    >
      <Icon className="h-3.5 w-3.5" />
      {formatDisplayValue(status || "Faturado")}
    </span>
  );
};

export default SaleStatusBadge;
